import http from "./constants/http";
import resources from "./constants/resources";

export const PartnersListSet = async (body) => {
  const res = await http(resources.PARTNERS).post(body);

  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};
